import { useIncidentsQuery } from "../useIncidentsQuery"

import { reportsQueryKeys } from "./queryKeys"

export function useReportStepQuery(
    uuid,
    queryParameters,
    config = {},
) {
    const url = `report_steps/${uuid}/`

    return useIncidentsQuery(
        url,
        reportsQueryKeys["step"](uuid),
        queryParameters,
        config,
    )
}
